import IconButton from '@mui/material/IconButton';
import type React from 'react';
import { useState } from 'react';

import { EyeIcon, EyeShowIcon } from '../../../assets/icons';
import type { Props } from '../Input/Input';
import Input from '../Input/Input';

const Password: React.FC<Props> = ({ hideEye, eyeButtonClassName, ...props }) => {
  const [type, setType] = useState<Props['type']>('password');
  const toggleType = () => setType(type === 'password' ? 'text' : 'password');
  const Icon = type === 'password' ? EyeIcon : EyeShowIcon;

  // TODO: Use translation https://jira.pyrsoftware.ca/jira/browse/LMS-18949 when is ready
  const message = {
    id: '1',
    defaultMessage: 'Toggle password visibility'
  };

  return (
    <Input {...props} showValidationTick={false} type={type}>
      {!hideEye && (
        <IconButton
          onClick={toggleType}
          aria-label={message.defaultMessage}
          size="small"
          className={eyeButtonClassName}
        >
          <Icon />
        </IconButton>
      )}
      {props.children}
    </Input>
  );
};

export default Password;
